document.addEventListener('alpine:init', () => {
  Alpine.data('TermsAndConditionsCheckbox', () => {
    return {
      updating: false,
      termsAccepted: false,
      async init() {
        this.$watch('termsAccepted', () => {
          this.updateTermsAccepted();
        });
      },
      async updateTermsAccepted() {
        this.updating = true;
        const timestamp = new Date(Date.now())
          .toLocaleDateString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZoneName: 'short',
          });

        try {
          await fetch(theme.routes.cart_update_url, {
            ...fetchConfigDefaults(),
            body: JSON.stringify({
              attributes: {
                'T&C Accepted At': this.termsAccepted ? timestamp : null,
              },
            }),
          });
        } catch (error) {
          console.error('Failed to update T&C acknowledgement:', error);
        }

        this.updating = false;
      },
    };
  });
});
